module.exports = "/fonts/glyphicons-halflings-regular.woff";


//////////////////
// WEBPACK FOOTER
// ../node_modules/bootstrap-sass/assets/fonts/bootstrap/glyphicons-halflings-regular.woff
// module id = 653
// module chunks = 0